// The recipient lines of a manual-run confirmation, built from the contact
// book as it stands, and the comparison that decides whether a confirmation
// prepared earlier still describes what would be sent (H38, M76).

export const INACTIVE_ACTION = "Edit this Function's Email Output and publish it again.";

// One recipient entry: "Name <address>" and, when the contact cannot receive
// mail, the reason — which blocks the confirmation.
export const recipientEntry = (id, contact) => {
  if (!contact) {
    return { id, label: 'Unknown recipient', blocked: `This contact no longer exists. ${INACTIVE_ACTION}` };
  }
  const name = contact.display_name || contact.email || id;
  const label = contact.email ? `${name} <${contact.email}>` : name;
  const status = contact.status || 'active';
  if (status !== 'active') {
    return { id, label, blocked: `This contact is ${status}. ${INACTIVE_ACTION}` };
  }
  const cleanup = contact.provider_suppression_cleanup;
  if (cleanup && cleanup.status !== 'complete') {
    return { id, label, blocked: 'This contact is still being restored. Try again shortly.' };
  }
  return { id, label, blocked: null };
};

const recipientShape = (confirmation) => (confirmation?.outputs || []).map((output) => ({
  blockId: output.blockId,
  recipients: (output.recipients || []).map((recipient) => [recipient.id, recipient.label, recipient.blocked]),
}));

// Whether two confirmations of the same version name different recipients:
// an id, an address, a name, or an eligibility that differs in any output.
export const confirmationChanged = (previous, fresh) => (
  JSON.stringify(recipientShape(previous)) !== JSON.stringify(recipientShape(fresh))
);

export const blockedRecipients = (confirmation) => (confirmation?.outputs || [])
  .flatMap((output) => (output.recipients || []).filter((recipient) => recipient.blocked));
